import { render } from "./Professions.vue?vue&type=template&id=15ccb228&scoped=true"
import script from "./Professions.vue?vue&type=script&lang=js"
export * from "./Professions.vue?vue&type=script&lang=js"

import "./Professions.vue?vue&type=style&index=0&id=15ccb228&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ccb228"]])

export default __exports__